import { HTMLElementProperty } from './HTMLElementProperty';
import { HTMLElementPropertyUnit } from './HTMLElementPropertyUnit';
import Enumerable from '../collections/Enumerable';
import FileSelectionDialogOptions from './FileSelectionDialogOptions';
import InvalidOperationError from '../system/InvalidOperationError';
export default class DOMUtils {
    static captureCamera(onFileSelected) {
        const input = document.createElement('input');
        input.type = 'file';
        input.capture = 'camera';
        input.onchange = () => {
            if (input.files) {
                onFileSelected(input.files[0]);
            }
        };
        input.click();
    }
    static clearValue(element, propertyName) {
        switch (propertyName) {
            case HTMLElementProperty.FullHeight:
            case HTMLElementProperty.FullWidth:
            case HTMLElementProperty.ScrollLeft:
            case HTMLElementProperty.ScrollTop:
                throw new InvalidOperationError(`Property ${propertyName}' cannot be cleared.`);
            default:
                element.style.removeProperty(propertyName);
        }
    }
    ;
    static ensureMiddleH(element, scrollableElem) {
        scrollableElem.scrollLeft = element.offsetLeft - scrollableElem.offsetLeft - (scrollableElem.clientWidth / 2 - element.clientWidth / 2);
    }
    ;
    static ensureMiddleV(element, scrollableElem) {
        scrollableElem.scrollTop = element.offsetTop - scrollableElem.offsetTop - (scrollableElem.clientHeight / 2 - element.clientHeight / 2);
    }
    ;
    static ensureVisibleH(element, scrollableElem) {
        scrollableElem.scrollLeft = element.offsetLeft - scrollableElem.offsetLeft;
    }
    ;
    static ensureVisibleV(element, scrollableElem) {
        scrollableElem.scrollTop = element.offsetTop - scrollableElem.offsetTop;
    }
    ;
    static findFirst(selector, parentNode) {
        if (parentNode) {
            return parentNode.querySelector(selector);
        }
        else {
            return document.querySelector(selector);
        }
    }
    static findAll(selector, parentNode) {
        if (parentNode) {
            return new Enumerable(parentNode.querySelectorAll(selector));
        }
        else {
            return new Enumerable(document.querySelectorAll(selector));
        }
    }
    static getComputedNumericValue(element, propertyName) {
        switch (propertyName) {
            case HTMLElementProperty.Scale:
                throw new InvalidOperationError(`Cannot get property ${propertyName}'.`);
            case HTMLElementProperty.FullHeight:
                return DOMUtils.getComputedNumericValue(element, HTMLElementProperty.Height) +
                    DOMUtils.getComputedNumericValue(element, HTMLElementProperty.MarginTop) +
                    DOMUtils.getComputedNumericValue(element, HTMLElementProperty.MarginBottom) +
                    DOMUtils.getComputedNumericValue(element, HTMLElementProperty.PaddingTop) +
                    DOMUtils.getComputedNumericValue(element, HTMLElementProperty.PaddingBottom);
            case HTMLElementProperty.FullWidth:
                return DOMUtils.getComputedNumericValue(element, HTMLElementProperty.Width) +
                    DOMUtils.getComputedNumericValue(element, HTMLElementProperty.MarginLeft) +
                    DOMUtils.getComputedNumericValue(element, HTMLElementProperty.MarginRight) +
                    DOMUtils.getComputedNumericValue(element, HTMLElementProperty.PaddingLeft) +
                    DOMUtils.getComputedNumericValue(element, HTMLElementProperty.PaddingRight);
            case HTMLElementProperty.ScrollLeft:
                return element.scrollLeft;
            case HTMLElementProperty.ScrollTop:
                return element.scrollTop;
            default:
                return parseInt(window.getComputedStyle(element)[propertyName]);
        }
    }
    ;
    static getComputedStyle(element) {
        return window.getComputedStyle(element);
    }
    ;
    static setNumericValue(element, propertyName, value, unit = HTMLElementPropertyUnit.Pixel) {
        switch (propertyName) {
            case HTMLElementProperty.FullHeight:
            case HTMLElementProperty.FullWidth:
                throw new InvalidOperationError(`Property ${propertyName}' cannot be set.`);
            case HTMLElementProperty.Scale:
                element.style.transform = `scale(${value + unit})`;
                break;
            case HTMLElementProperty.Opacity:
                element.style.opacity = String(value);
                break;
            case HTMLElementProperty.ScrollLeft:
                element.scrollLeft = value;
                break;
            case HTMLElementProperty.ScrollTop:
                element.scrollTop = value;
                break;
            case HTMLElementProperty.TranslateX:
                element.style.transform = `translateX(${value + unit})`;
                break;
            case HTMLElementProperty.TranslateY:
                element.style.transform = `translateY(${value + unit})`;
                break;
            default:
                element.style[propertyName] = value + unit;
        }
    }
    ;
    static showFileSelectionDialog(onFileSelected, options) {
        options = new FileSelectionDialogOptions(options);
        const input = document.createElement('input');
        input.type = 'file';
        input.multiple = options.multiple;
        input.accept = options.filter;
        input.onchange = () => {
            if (input.files) {
                const files = [];
                for (let i = 0; i < input.files.length; i++) {
                    files.push(input.files[i]);
                }
                onFileSelected(files);
            }
        };
        input.click();
    }
    static scrollToH(scrollableElement, targetElement, offset = 0) {
        scrollableElement.scrollLeft = targetElement.getBoundingClientRect().left + scrollableElement.getBoundingClientRect().left + offset;
    }
    static scrollToV(scrollableElement, targetElement, offset = 0) {
        scrollableElement.scrollTop = targetElement.getBoundingClientRect().top + scrollableElement.getBoundingClientRect().top + offset;
    }
}
//# sourceMappingURL=DOMUtils.js.map